import InplayFallbackEventCard from './_inplay-fallback-event-card.js'
import SportFallbackEventCard from './_sport-fallback-event-card.js'

export default {
  name: 'FallbackEventCardTypes',
  values: {
    inplay: {
      configSet: InplayFallbackEventCard,
      configValues: {
        title: '$EVENT_CARDS.FALLBACK.INPLAY.TITLE',
        content: '$EVENT_CARDS.FALLBACK.INPLAY.CONTENT',
      },
    },
    sport: {
      configSet: SportFallbackEventCard,
      configValues: {
        title: '$EVENT_CARDS.FALLBACK.SPORT.TITLE',
        content: '$EVENT_CARDS.FALLBACK.SPORT.CONTENT',
      },
    },
  },
  meta: {
    extendable: true,
  },
}
